import axios from 'axios';

const api = axios.create({baseURL: "https://inaarees.gov.ao/backend"});

export default api;